/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Room_Association_Form_RoomsInputs */



/**
* | output |
* | --- |
* | "Associated room(s)" |
*
* @param {Air_Handler_Unit_Room_Association_Form_RoomsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_room_association_form_rooms = /** @type {((inputs?: Air_Handler_Unit_Room_Association_Form_RoomsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Room_Association_Form_RoomsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Associated room(s)")
	return /** @type {LocalizedString} */ ("Pièce(s) associée(s)")
});